interface Scripts {
  name: string;
  src: string;
  asyncFlag?: boolean;
  enabled?: boolean;
  token?: string;
}

export const scriptStore: Scripts[] = [
  {
    name: "sportsbook",
    src: "https://sportsbook.ngbras.com/",
    enabled: false,
  },
  {
    name: "sportradar",
    src: "https://s5.sir.sportradar.com/iframescript.js",
    enabled: false,
  },
];
